import type {
    AssemblyMediaTextFields,
    Content,
} from '@beat-venues/common-types';
import { mockContentImageFull } from './content-image.mock';
import { mockContentRichTextWithParagraph } from './content-rich-text.mock';

export const mockAssemblyMediaTextBase: Content<
    'assemblyMediaText',
    AssemblyMediaTextFields
> = {
    sys: {
        id: '12SRM7zbe1AS2vJUy7AY0v',
        contentType: {
            sys: {
                id: 'assemblyMediaText',
            },
        },
    },
    fields: {
        title: 'Justin Bieber',
        media: mockContentImageFull,
        copy: mockContentRichTextWithParagraph.fields.content,
        mediaPosition: 'Left',
        mediaLayout: '50-50',
    },
};

export const mockAssemblyMediaTextRight: Content<
    'assemblyMediaText',
    AssemblyMediaTextFields
> = {
    ...mockAssemblyMediaTextBase,
    fields: {
        ...mockAssemblyMediaTextBase.fields,
        mediaPosition: 'Right',
    },
};
